/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';
import {buttonIcon} from "./index";

function defineBlock(context) {
    return {
        init: function () {
            this.appendValueInput("TEXT")
                .appendField("set")
                .appendField(new Blockly.FieldImage(buttonIcon, 60, 50, "button icon", null), 'buttonIcon')
                .appendField(new Blockly.FieldWidgetsDropdown(context,"button", undefined, '- select -'), "ID")
                .appendField("text to");
            this.setPreviousStatement(true);
            this.setNextStatement(true);
            this.setOutput(false); // add appropriate checks
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Set the placeholder display text of the provided widget');
            this.setHelpUrl(Blockly.BASE_HELP_URL + '#buttons');
        },

        onchange: function() {
            if (this.getField('buttonIcon')?.imageElement_) {
                this.getField('buttonIcon').setTooltip('Button');
            }
        }
    }
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let id = block.getFieldValue("ID");
            let text = Blockly.JavaScript.valueToCode(block, 'TEXT', Blockly.JavaScript.ORDER_NONE);
            let code = 'Snap.widgets.button.setDisplayText("' + id + '", ' + text + ');\n';
            return code;
        }
    }
}


const SetButtonDisplayText = function (props) {
    let name = "snap_set_button_display_text";
    SetButtonDisplayText.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    if (props.widgets.length < 1) {
        return null;
    }

    return (
        <block type={name}>
            {props.widget?.id
                ? <field name="ID">{props.widget.id}</field>
                : null
            }
            <value name="TEXT">
                <shadow type="text"/>
            </value>
        </block>
    );
}

SetButtonDisplayText.propTypes = {
    context: PropTypes.object.isRequired,
    widgets: PropTypes.array.isRequired,
    widget: PropTypes.object,
};

export default SetButtonDisplayText;
